export default __webpack_public_path__ + "static/media/MICE-meeting-dt@2x.18a45dc6.jpg";